import { render, staticRenderFns } from "./ChooseLabProductView.vue?vue&type=template&id=246094d5&"
import script from "./ChooseLabProductView.vue?vue&type=script&lang=ts&"
export * from "./ChooseLabProductView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports